var ehmliiv = ehmliiv || {};

ehmliiv.api = {
  baseURI: '/api',
  version: '1',
  getURI: function (path) {
    return this.baseURI + '/v' + this.version + '/' + path;
  }
};

ehmliiv.app = {
  init: function () {

    var self = this;

    this.bindEvents();

  },

  bindEvents: function () {
    this.bindStaticEvents();
    this.bindDynamicEvents();
  },

  bindStaticEvents: function (scope) {

    var self = this;

    if (!scope) {
      var scope = $(document);
    }

    self.addOptionLabel($('.js-select-label', scope));
    self.chainedDropdownToggler($('.js-chained-dropdown', scope));
    self.checkBreakWord($('.js-breakword', scope));
    // self.disableMultInputs(scope); // NOTE: Put this on hold, see LIIV-958 in Jira
    self.dialogHandler();
    //Enable if you want ehm-web style dropdowns (css class select)
    self.renderEhmDropDowns(scope);

    self.showDropDowns(scope);

    $('.js-select-label', scope).on('change', function (e) {
      self.addOptionLabel($(this));
    });

    var popup = $('.popup-body .js-close-popup:first', scope);

    if (popup.length > 0) {
      $(document).on('keydown.popup', function (e) {
        if (e.keyCode == 27) {
          self.closePopup();
        }
      });
    }

    $('.js-open-popup', scope).on('click', function (e) {
      e.stopPropagation();
      $(document).on('keydown.document', function (e) {
        if (e.keyCode == 27) {
          self.closePopup();
        }
      });
    });

    $('.js-open-client-modal', scope).on('click', function (e) {
      e.stopPropagation();
      e.preventDefault();
      self.openModal($(this));
    });

    $('.table__full--search .table__list-item', scope).on('click', function (e) {
      var trigger = $(this);

      var visible = trigger.hasClass('articles-visible');
      var sibling = trigger.next('.table__list-item--article');
      var expandButton = trigger.find('.expand-button');

      if (visible) {
        trigger.removeClass('articles-visible');
        sibling.removeClass('articles-visible');
        expandButton.attr('aria-expanded', 'false').removeClass('active');
      } else {
        trigger.addClass('articles-visible');
        sibling.addClass('articles-visible');
        expandButton.attr('aria-expanded', 'true').addClass('active');
      }

    });

    $('#article-table td', scope).on('click', function (e) {
      var trigger = $(this);

      var parent = trigger.parents('tr:first');
      var target_id = parent.data('visa-artikel');
      var target = $('.visaArtikelBackend' + target_id);

      target.click();
    });

    $('.expand-button').on('keydown', function(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        $(this).closest('.table__list-item').click();
      }
    });

    $(window).resize(function () {
      if (this.resizeTO) {
        clearTimeout(this.resizeTO);
      }
      this.resizeTO = setTimeout(function () {
        $(this).trigger('resizeEnd');
      }, 500);
    });

    $(window).bind('resizeEnd', function () {
      ehmliiv.app.dialogHandler();
    });

  },

  bindDynamicEvents: function (scope) {
    var self = this;

    if (!scope) {
      var scope = $(document);
    }

    // $('js-close-popup', scope).on('click', self.closePopup);

    // Hantera länkar
    $('a[href^="visaProdukt.xhtml"], a[href^="visaHvProdukt.xhtml"], a[href^="visaArtikel.xhtml"], a[href^="visaHvArtikel.xhtml"]', scope).on('click', function(e) {
      e.preventDefault(); 
      e.stopPropagation();
      
      var destination = $(this).attr('href');
      
      window.location = destination;
    });

    // Hantera klickbara rader
    $('tr:has(a[href^="visaArtikel.xhtml"]), tr:has(a[href^="visaHvArtikel.xhtml"])', scope).on('click', function(e) {
      
      if (!$(e.target).closest('a').length) {
          e.stopPropagation();
          
          var destination = $(this).find('a[href^="visaArtikel.xhtml"], a[href^="visaHvArtikel.xhtml"]').attr('href');
          window.location = destination;
      }
    });

    $('[data-popup-href]', scope).on('click', function (e) {
      e.stopPropagation();
      var template = $(this).data('template');
      var href = $(this).data('popup-href');

      $.get(ehmliiv.api.getURI(href), function (resp) {
        self.openPopup(resp);
      });
    });

    $('.js-dropdown', scope).on('click', function (e) {
      $(this).toggleClass('active');
    });

    $('.tipsy', scope).tipsy({
      opacity: 1,
      gravity: 'nw'
    });

    $('.tipsy-html', scope).tipsy({
      opacity: 1,
      gravity: 'nw',
      html: true
    });

    self.formSubmitHandler(scope);

    $('.js-chained-dropdown', scope).on('change', function () {
      self.chainedDropdownToggler($(this));
    });

    $('.js-confirm', scope).on('click', function (e) {
      if (!confirm($(this).data('confirm'))) {
        e.preventDefault();
        return false;
      }
    });

    $('.product-info__row').each(function() {
      const $dd = $(this).find('dd');
      
      if ($dd.length) {
          // Get the actual content height
          const contentHeight = $dd[0].scrollHeight;
          
          // If content is taller than our base height (45px), make it span 2 rows
          if (contentHeight > 45) {
              $(this).addClass('multi-line');
          }
      }
    });

  },

  chainedDropdownToggler: function (stack) {
    if (stack.length > 0) {
      stack.each(function () {

        var dropdown = $(this);

        if (!dropdown.prop('disabled')) {
          var datepickerPF = PrimeFaces.widgets['tillhandahallsFrom'];
          var datepickerJQ = datepickerPF.getJQ();

          if (datepickerJQ.length > 0) {
            var value = dropdown.val();
            var column = datepickerJQ.parents('.editmode-layout__column:first');
            var input = datepickerJQ.find('input');

            if (value.toLowerCase().indexOf('y:') === -1) {
              datepickerPF.enable();
              column.removeClass('field-disabled');
              input.prop('disabled', false);
            } else {
              datepickerPF.disable();
              column.addClass('field-disabled');
              input.prop('disabled', true);
            }
          }
        }
      });
    }
  },

  checkBreakWord: function (cells) {
    cells.each(function () {
      var cell = $(this);
      var words = cell.text().split(' ');
      var maxWordLength = cell.data('max-word-length') || 30;
      for (var i = 0; i < words.length; i++) {
        if (words[i].length >= maxWordLength) {
          cell.addClass('breakword');
          break;
        }
      }
    });
  },

  disableMultInputs: function (scope) {
    var amount = $('.js-input-amount', scope);
    if (amount.length > 0) {
      var mult2 = $('.js-input-mult2', scope);
      var mult1 = $('.js-input-mult1', scope);

      mult1.on('keyup', function () {
        ehmliiv.app.disableIfEmpty(mult2, mult1);
      });
      mult1.trigger('keyup');

      amount.on('keyup', function () {
        ehmliiv.app.disableIfEmpty(mult1, amount);
        mult1.trigger('keyup');
      });
      amount.trigger('keyup');
    }
  },

  disableIfEmpty: function (el, elToCheck) {
    el.prop('disabled', elToCheck.val().length === 0 || elToCheck.prop('disabled'));
  },

  renderEhmDropDowns: function (scope) {
    if (window.ehm && window.ehm.updateMultiselects) {
      $('.ehm-select', scope).addClass('select');
      window.ehm.updateMultiselects();
      // Hot fix to prevent dropdowns being opened when user presses enter in same form
      $('.multiselect__selected').attr('type', 'button');
      // Hot fix to implement disabled dropdowns
      $('.multiselect select[disabled]').each(function () {
        $(this).closest('.multiselect').find('.multiselect__selected').prop('disabled', true);
      });
      // Adjust min width of dropdown to match their options
      var optionsToAdjust = $('.ehm-select .multiselect__options');
      setTimeout(function () {
        optionsToAdjust.each(function () {
          var options = $(this);
          var minWidth = options.outerWidth();
          var wrapper = options.closest('.select');
          var parentCell = wrapper.closest('td, .editmode-layout__field');
          if (parentCell.length > 0 && parentCell.width() < minWidth) {
            minWidth = parentCell.width();
          }
          wrapper.css('min-width', minWidth + 'px');
        });
      }, 50);
    }
    this.showDropDowns();
  },

  showDropDowns: function (scope) {
    $('.ehm-select', scope).removeClass('ehm-select');
  },

  formSubmitHandler: function (scope) {
    var forms = $('.oldie form input[placeholder]', scope).parents('form:first');

    forms.on('submit', function (e) {
      Placeholders.disable();
    });
  },

  doHiddenClick: function (id) {
    $(".artikel-id-" + id).click();
  },

  closePopup: function (e) {
    var iframe = $("iframe:first").contents();
    if (iframe.length > 0) {
      var trigger = $('.js-close-popup:first', iframe);
      if (trigger.length > 0) {
        trigger.click();
        $(document).off('keydown.document');
      }
    } else {
      var trigger = $('.js-close-popup:first');
      if (trigger.length > 0) {
        trigger.click();
        $(document).off('keydown.popup');
      }
    }
  },

  addOptionLabel: function (stack) {
    stack.each(function () {
      var select = $(this);
      var option = select.find('option:selected');
      var label = select.data('labelname');
      option.html(label + ': ' + option.html());
    });
  },

  dialogHandler: function () {

    var w = $(window);
    var vph = w.height();
    var b = $('body');
    var style = $('#dialogstyle');

    if (!b.hasClass('.popup-body')) {
      style.remove();
      $('<style id="dialogstyle">.ui-dialog iframe { max-height: ' + (vph - 100) + 'px; }</style>').appendTo('head');
    }

  },

  // Check if a date is a holiday and return accurate options for primefaces calendar
  checkHoliday: function (date) {
    var year = date.getFullYear();

    var month = date.getMonth() + 1;
    var monthString = (month < 10 ? '0' : '') + month;

    var day = date.getDate();
    var dayString = (day < 10 ? '0' : '') + day;

    if (svenskaHelgdagar.indexOf(year + '-' + monthString + '-' + dayString) === -1) {
      return [true, ''];
    } else {
      return [true, 'ui-datepicker-holiday'];
    }
  },

  openModal: function ($trigger) {
    var $modalLink = $('.js-open-client-modal');
    var $body = $('body');
    var $window = $(window);
    var markup = $('#' + $trigger.data('target')).html();
    $body.append('<div class="ui-widget-overlay client-modal-overlay"></div>');
    var $overlay = $('.client-modal-overlay');
    $body.append('<div class="ui-dialog client-modal-dialog"><div class="client-modal">' + markup + '</div></div>');
    var $modal = $('.client-modal-dialog');
    $body.addClass('client-modal-overflow-hidden');
    $closeModalButton = $modal.find('.js-client-modal-close');
    
    var positionModal = function () {
      $overlay.css('top', $window.scrollTop() + 'px').css('height', $body.height() + 300 + 'px');
      $modal.css('top', ($window.scrollTop() + 50) + 'px').css('maxHeight', ($window.height() - 100) + 'px');
    };
    
    var closeModal = function () {
      $overlay.removeClass('show');
      $modal.removeClass('show');
      $(document).off('keydown.modal');
      $window.off('resize', positionModal);
      $body.removeClass('client-modal-overflow-hidden');
      setTimeout(function () {
        $overlay.remove();
        $modal.remove();
        $modalLink.focus();
      }, 100);
    };

    var handleTabKey = function (e) {
      var focusableElements = $modal.find('a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select');
      var firstElement = focusableElements[0];
      var lastElement = focusableElements[focusableElements.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === firstElement) {
          lastElement.focus();
          e.preventDefault();
        }
      } else { 
        if (document.activeElement === lastElement) {
          firstElement.focus();
          e.preventDefault();
        }
      }
    };

    var handleKeyDown = function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        closeModal();
      } else if (e.key === 'Tab' || e.keyCode === 9) {
        handleTabKey(e);
      }
    };

    $closeModalButton.on('click', closeModal);
    $overlay.on('click', closeModal);
    $overlay.on('touchend', closeModal);
    $(document).on('keydown.modal', handleKeyDown);
    $window.on('resize', positionModal);

    setTimeout(function () {
      positionModal();
      $overlay.addClass('show');
      $modal.addClass('show');

      if ($trigger.is(':focus')) {
        var firstFocusableElement = $modal.find('a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select').first();
        firstFocusableElement.focus();
      }
    }, 10);
  },
  downloadMonitorStart: function () {
    PF('statusDialog').show();
  },
  downloadMonitorStop: function () {
    PF('statusDialog').hide();
  }
};


$().ready(function () {
  ehmliiv.app.init();
});